import React from 'react';
import {Button, Modal} from 'react-bootstrap';
import {useTranslation} from "react-i18next";
import {ButtonSpinner} from "../ButtonSpinner/ButtonSpinner";

interface ConfirmationModalProps {
    body: React.ReactNode;
    show: boolean;
    title: string;
    isLoading?: boolean;
    isDisableConfirm?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  title,
  body,
  isLoading,
  isDisableConfirm,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation();

  React.useEffect(() => {
  if (!show) return;

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
    onCancel();
    } else if (e.key === 'Enter') {
    const target = e.target as HTMLElement;
    const tagName = target.tagName.toLowerCase();
    if (tagName === 'textarea' || tagName === 'input' || tagName === 'select') {
      return;
    }
    if (!isDisableConfirm && !isLoading) {
      onConfirm();
    }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
  }, [show, isDisableConfirm, isLoading, onConfirm, onCancel]);

  return (
  <Modal show={show} onHide={onCancel}>
    <Modal.Header closeButton>
    <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    {body}
    </Modal.Body>
    <Modal.Footer>
    <Button variant="light" onClick={onCancel}>
      {t('ConfirmationModal.Cancel')}
    </Button>
    <ButtonSpinner
      title={t('ConfirmationModal.Confirm')}
      isLoading={isLoading}
      isDisabled={isDisableConfirm}
      onClick={onConfirm}
    />
    </Modal.Footer>
  </Modal>
  );
};
